import { useNavigate } from 'react-router';
import { QUERY_KEYS_ENUM } from '../../static/query-keys.enum';
import { useQuery } from '@tanstack/react-query';
import { fetchEmailChannel } from '../../api';
import { redirectTo404 } from '../../utils/error';

interface UseGetEmailChannelDetailProps {
  enabled?: boolean;
}

export const useGetEmailChannelDetail = (
  id: string = '',
  { enabled = true }: UseGetEmailChannelDetailProps = {}
) => {
  const navigate = useNavigate();
  return useQuery({
    queryKey: [QUERY_KEYS_ENUM.channelDetail, id],
    queryFn: async () => {
      try {
        const response = (await fetchEmailChannel(id)).data;
        return response;
      } catch (error) {
        redirectTo404(navigate, error);
      }
    },
    enabled: !!id && enabled,
    retry: 1
  });
};
